<template>
   <div class='page_content'>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :buttonFlag="false" :showRefresh="true"></v-button>
         <div class="page_content_top_line">
            <el-form :inline="true" label-width="100px" :model="getRequestData" class="demo-form-inline" @submit.native.prevent size="mini">
               <el-form-item label="开始时间">
                  <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
                  <el-date-picker class="form_codition" size="mini" v-model="getRequestData.start" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
               </el-form-item>
               <el-form-item label="结束时间">
                  <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
                  <el-date-picker class="form_codition" size="mini" v-model="getRequestData.end" @change="changeTime" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
               </el-form-item>
               <el-form-item label="设备名称">
                  <label slot="label" :style="$common.labelStyle('设备名称')" v-html="$common.htmlLabel('设备名称')"></label>
                  <el-input class="form_codition" v-model.trim="getRequestData.fmName" clearable></el-input>
               </el-form-item>
               <el-form-item>
                  <el-button type="primary" size="mini" @click="searchData">查询</el-button>
               </el-form-item>
            </el-form>
         </div>
      </div>
      <div class="page_content_center">
         <el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
            <el-table-column align="center" label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="fmName" min-width="120" label="设备名称"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="spec" min-width="120" label="规格"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="manufacturer" min-width="120" label="生产厂商"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="opmName" min-width="120" label="使用人"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="useDate" min-width="120" label="开始时间">
               <template slot-scope="scope">
                  <span v-if="scope.row.useDate">
                     {{ $common.getLocalTime(scope.row.useDate) }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="useEndDate" min-width="120" label="结束时间">
               <template slot-scope="scope">
                  <span v-if="scope.row.useEndDate">
                     {{ $common.getLocalTime(scope.row.useEndDate) }}
                  </span>
               </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="useReason" min-width="150" label="用途"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip prop="remark" min-width="150" label="备注"></el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-drawer :close-on-press-escape="true" :title="diaType == 0 ? '新增' : '修改'" :visible.sync="dialogFlag" :with-header="false" :append-to-body="true" :direction="'ltr'" size="50%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED">
               <v-tabs :type="diaType" :activeName="tabForm[0].jciName" :name="'jciName'" :value="'jciName'" :tabslist="tabForm">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <div v-if="scope.index == 0">
                           <el-form :model="sendDataInfo" id="mainInfo" class="baseForm" label-width="120px" ref="sendDataInfo" :show-message="false">
                              <el-row>
                                 <el-form-item label="设备名称" prop="fmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('设备名称')" v-html="$common.htmlLabel('设备名称')"></label>
                                    <!-- 设备名称 -->
                                    <el-input @focus="openSearch(253286358061056, 0, 'fmName', 'fmName,fmId,spec,manufacturer')" v-model="sendDataInfo.fmName" clearable>
                                       <el-button @click="openSearch(253286358061056, 0, 'fmName', 'fmName,fmId,spec,manufacturer')" slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                 </el-form-item>
                                 <el-form-item label="规格" prop="spec">
                                    <label slot="label" :style="$common.labelStyle('规格')" v-html="$common.htmlLabel('规格')"></label>
                                    <!-- 规格 -->
                                    <el-input v-model="sendDataInfo.spec" readonly></el-input>
                                 </el-form-item>
                                 <el-form-item label="生产厂商" prop="manufacturer">
                                    <label slot="label" :style="$common.labelStyle('生产厂商')" v-html="$common.htmlLabel('生产厂商')"></label>
                                    <!-- 生产厂商 -->
                                    <el-input v-model="sendDataInfo.manufacturer" readonly></el-input>
                                 </el-form-item>
                                 <el-form-item label="使用人" prop="opmName" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('使用人')" v-html="$common.htmlLabel('使用人')"></label>
                                    <!-- 设备名称 -->
                                    <el-input @focus="openSearch(4444770562019328, 0, 'opmName', 'opmName,opmId')" v-model="sendDataInfo.opmName" clearable>
                                       <el-button @click="openSearch(4444770562019328, 0, 'opmName', 'opmName,opmId')" slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                 </el-form-item>
                                 <el-form-item label="开始时间" prop="useDate" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('开始时间')" v-html="$common.htmlLabel('开始时间')"></label>
                                    <!-- 设备名称 -->
                                    <df-date :isType="true" v-model="sendDataInfo.useDate"></df-date>
                                 </el-form-item>
                                 <el-form-item label="结束时间" prop="useEndDate" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('结束时间')" v-html="$common.htmlLabel('结束时间')"></label>
                                    <!-- 设备名称 -->
                                    <df-date :isType="true" v-model="sendDataInfo.useEndDate"></df-date>
                                 </el-form-item>
                                 <el-form-item label="用途" prop="useReason" :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('用途')" v-html="$common.htmlLabel('用途')"></label>
                                    <!-- 设备名称 -->
                                    <el-input type="textarea" v-model="sendDataInfo.useReason" clearable></el-input>
                                 </el-form-item>
                                 <el-form-item label="备注" prop="remark">
                                    <label slot="label" :style="$common.labelStyle('备注')" v-html="$common.htmlLabel('备注')"></label>
                                    <!-- 设备名称 -->
                                    <el-input type="textarea" v-model="sendDataInfo.remark" clearable></el-input>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foots">
               <el-button @click="dialogFlag = false">取 消</el-button>
               <el-button type="primary" @click="diaConfirm">确 定</el-button>
            </div>
         </div>
      </el-drawer>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
   components: { SearchScheme },
   data() {
      return {
         buttonList: [],
         diaType: 0,
         dialogFlag: false,
         selectedDataIndex: 0,
         tableHeight: 500,
         returnData: {
            list: [],
            total: 0, // 总条数
         },
         getRequestData: {
            fmName: '',
            page: 1,
            rows: 30,
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
         },
         tabForm: [
            {
               jciName: "",
               jurconfigform: [],
            }
         ],
         sendDataInfo: {
            emuId: "",
            fmName: "",
            fmId: "",
            opmName: "",
            opmId: "",
            useDate: "",
            useEndDate: "",
            useReason: "",
            remark: "",
            spec: "",
            manufacturer: "",
         },
         DialogVisible: false,
         seType: "",
         seId: "",
         sField: "",
         seWidth: "",
         seTitle: "",
         parentSearchData: {},
      }
   },
   watch: {
      dialogFlag() {
         if (!this.dialogFlag) {
            for (const key in this.sendDataInfo) {
               this.sendDataInfo[key] = ""
            }
         }
      },
      "sendDataInfo.useEndDate": {
         handler: function (newValue) {
            if (newValue !== "" && newValue > 0) {
               if (this.sendDataInfo.useDate >= newValue) {
                  this.$message({
                     message: "结束日期不能小于开始日期",
                     type: "warning"
                  });
                  // 默认设置为开始日期+1天
                  this.sendDataInfo.useEndDate = this.sendDataInfo.useDate + 24 * 60 * 60 * 1000;
               }
            }
         },
         deep: true,
      }
   },
   created() {
      var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
      for (const key in obj) {
         this.$set(this.getRequestData, key, obj[key])
      }
      this.getButtonList()
      this.getDataList()
   },
   methods: {
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
// 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 0:
               this.diaType = actionData.actionType
               this.tabForm[0].jciName = '新增设备设施使用'
               this.dialogFlag = true
               break;
            case 1:
               var dataInfo = this.returnData.list[this.selectedDataIndex]
               if (!dataInfo) {
                  this.$message({
                     message: '请先选中要操作的数据',
                     type: 'error'
                  });
                  return false
               }
               for (const key in this.sendDataInfo) {
                  this.sendDataInfo[key] = dataInfo[key]
               }
               this.diaType = actionData.actionType
               this.tabForm[0].jciName = '修改设备设施使用'
               this.dialogFlag = true
               break;
            case 2:
               this.delDataAction()
               break;
            case 88:
               this.showPrintPlan()
               break

         }
      },
      getPageInfo() {
         this.getDataList()
      },
      showPrintPlan() {
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         if (!dataInfo) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            });
            return false;
         }
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(dataInfo.emuId, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'))
         } else {
            return
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },
      async getDataList() {
         let responseData = await this.$http.emusequery(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.total = responseData.result.total
            this.selectedDataIndex = 0
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.seType = type
         this.DialogVisible = true
         this.seId = sId
         this.sField = sField
         if (type == 'opmName') {
            this.parentSearchData = {
               opmBuyer: ''
            }
         }
      },

      paramValue(val) {
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
      },
      changeInputModel(val) {
         console.log(val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val)
         }
      },
      diaConfirm() {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               console.log('error submit!!');
               return false;
            }
         });
      },
      async sub() {
         if (this.diaType == 0) {
            var responseData = await this.$http.emuseadd(this.sendDataInfo)
         } else {
            var responseData = await this.$http.emuseupdate(this.sendDataInfo)
         }
         if (responseData.status == 200) {
            this.$message({
               message: '操作成功',
               type: 'success'
            });
            this.dialogFlag = false
            this.getDataList()

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 删除数据
      delDataAction() {
         var dataInfo = this.returnData.list[this.selectedDataIndex]
         if (!dataInfo) {
            this.$message({
               message: '请先选中要操作的数据',
               type: 'error'
            });
            return false
         }

         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.emuId]
            }
            let responseData = await this.$http.emusedelete(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });
      },
   },
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
}
</script>

<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-drawer {
   outline: none;
}
</style>